import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';
import datapoints from '../datapoints';
import { GetBrandsSubscriptionsServiceResponse } from 'owa-brands-subscription';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

const setServiceCallState = action(
    'SET_SERVICE_CALL_STATE',
    (state: BrandSubscriptionServiceCallState) => ({
        state: state,
    })
);

const loadBrandsSubscriptions = action('LOAD_BRANDS_SUBSCRIPTIONS', () =>
    addDatapointConfig(datapoints.LoadBrandsSubscriptions)
);

const updateBrandsSubscriptions = action(
    'UPDATE_BRANDS_SUBSCRIPTIONS',
    (response: GetBrandsSubscriptionsServiceResponse) => ({
        response: response,
    })
);

const onUnsubscribeFromBrand = action('ON_UNSUBSCRIBE_FROM_BRAND', (smtpIdentifier: string) => ({
    smtpIdentifier: smtpIdentifier,
}));

export {
    setServiceCallState,
    loadBrandsSubscriptions,
    updateBrandsSubscriptions,
    onUnsubscribeFromBrand,
};
